<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card v-if="$_get(item, 'student.id')">
      <v-card-title class="primary white--text text-uppercase">
        Sửa thực đơn
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" class="py-4">
          <v-row>
            <v-col cols="6">
              <div class="text-caption my-0">Học sinh</div>
              <CardStudentName :isShowCode="false" :student="item.student" />
            </v-col>
            <v-col class="d-flex justify-space-between align-center" cols="6">
              <div>
                <div class="text-caption my-0">Ngày sinh</div>
                <span class="black--text">{{ $_get(item.student, 'dob') | ddmmyyyy }}</span>
              </div>
              <div>
                <div class="text-caption my-0">Mã số</div>
                <span class="black--text">{{ $_get(item.student, 'code') | getStudentCode }}</span>
              </div>
              <div>
                <div class="text-caption my-0">Lớp</div>
                <span class="black--text">{{ $_get(item.student, 'currentClass.title') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              Ngày
              <span class="font-weight-bold">
                {{ item.date | ddmmyyyy }}
              </span>
            </v-col>

            <!-- thuc don hien tai -->
            <v-row class="px-3">
              <v-col cols="4">
                <div>
                  <p class="text-caption my-0">Thực đơn hiện tại</p>
                  <span class="text-subtitle-2 font-weight-black">{{
                    $_get(item, 'studentMenu.selectedMenu') | selectedMenu
                  }}</span>
                </div>
              </v-col>
              <v-col cols="3" class="d-flex justify-center align-start">
                <v-icon large>mdi-arrow-right</v-icon>
              </v-col>
              <v-col cols="5">
                <v-select
                  v-model="selectedMenu"
                  :items="selectedMenuFilter"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  clearable
                  label="Thực đơn mới"
                  @change="onSelectedMenuChanged"
                />
              </v-col>
            </v-row>

            <!-- so luong dang ky -->
            <v-row class="px-3">
              <v-col class="" cols="4">
                <div>
                  <p class="text-caption my-0">Số lượng suất ăn đăng ký</p>
                  <span class="text-subtitle-2 font-weight-black">{{
                    $_get(
                      item,
                      'studentMenu.amount',
                      $_get(item, 'studentMenu.selectedMenu') !== 'menu1' &&
                        $_get(item, 'studentMenu.selectedMenu') !== 'menu2'
                        ? 0
                        : 1
                    )
                  }}</span>
                </div>
              </v-col>
              <v-col cols="3" class="d-flex justify-center align-start">
                <v-icon large>mdi-arrow-right</v-icon>
              </v-col>
              <v-col cols="5">
                <!-- :class="isRequiredRegisterAmount ? 'required' : ''"
                  :rules="isRequiredRegisterAmount ? [$rules.required] : null" -->
                <v-select
                  v-model="registedAmount"
                  :items="registedAmountFilter"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  :disabled="!enableRegisterAmount"
                  :label="this.registedAmount === 0 ? '0' : 'Số lượng đăng ký'"
                />
              </v-col>
            </v-row>

            <!-- trang thai an -->
            <v-row class="px-3">
              <v-col class="" cols="4">
                <div>
                  <p class="text-caption my-0">Trạng thái ăn thực tế</p>
                  <span class="text-subtitle-2 font-weight-black">{{
                    $_get(item, 'mealTransferStatus') | mealTransferStatus
                  }}</span>
                </div>
              </v-col>
              <v-col cols="3" class="d-flex justify-center align-start">
                <v-icon large>mdi-arrow-right</v-icon>
              </v-col>
              <v-col cols="5">
                <v-select
                  v-model="realStatus"
                  :items="mealTransferStatusesFilter"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  clearable
                  label="Trạng thái ăn thực tế"
                  :disabled="!enableEditMealTransferStatus"
                  @change="onMealTransferStatusChanged"
                />
              </v-col>
            </v-row>

            <!-- so luong an thuc te -->
            <v-row class="px-3">
              <v-col class="" cols="4">
                <div>
                  <p class="text-caption my-0">Số lượng ăn thực tế</p>
                  <span class="text-subtitle-2 font-weight-black">{{ $_get(item, 'mealTransfer.amount', 0) }}</span>
                </div>
              </v-col>
              <v-col cols="3" class="d-flex justify-center align-start">
                <v-icon large>mdi-arrow-right</v-icon>
              </v-col>
              <v-col cols="5">
                <v-select
                  v-model="realAteAmount"
                  :items="realAteAmountFilter"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  :label="realStatus && realStatus !== 'ate' ? '0' : 'Số lượng ăn thực tế'"
                  :disabled="!enableRealAteAmount"
                />
              </v-col>
            </v-row>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save()">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName'
import { get } from 'lodash'
import { Menu } from '../../plugins/api'
import moment from 'moment'

export default {
  components: {
    CardStudentName
  },
  data() {
    return {
      dialog: false,
      selectedMenu: '',
      registedAmount: null,
      realStatus: '',
      realAteAmount: null
    }
  },
  props: {
    state: Boolean,
    item: {
      type: Object,
      default: () => {}
    },
    student: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('constant', ['menus', 'mealAmountList', 'mealTransferStatuses']),
    selectedMenuFilter() {
      if (get(this.item, 'mealTransferStatus') === 'ate') {
        return this.menus.filter(s => s.value !== '0' && get(this.item, 'studentMenu.selectedMenu') !== s.value)
      }
      return this.menus.filter(s => get(this.item, 'studentMenu.selectedMenu') !== s.value)
    },
    registedAmountFilter() {
      if (
        get(this.item, 'studentMenu.selectedMenu') !== 'menu1' &&
        get(this.item, 'studentMenu.selectedMenu') !== 'menu2'
      ) {
        if (get(this.item, 'studentMenu.selectedMenu') === '0') {
          // không đăng ký ăn
        } else {
          // chưa đăng ký
          return this.mealAmountList.filter(s => s.value !== 0)
        }
      } else {
        // có đăng ký món ăn
        return this.mealAmountList.filter(s => s.value !== 0 && get(this.item, 'studentMenu.amount') !== s.value)
      }

      return this.mealAmountList
    },
    mealTransferStatusesFilter() {
      return this.mealTransferStatuses.filter(
        s => s.value !== 'not-eat' && get(this.item, 'mealTransferStatus') !== s.value
      )
    },
    realAteAmountFilter() {
      if (get(this.item, 'mealTransferStatus') === 'ate') {
        return this.mealAmountList.filter(s => s.value !== 0 && get(this.item, 'mealTransfer.amount') !== s.value)
      }
      return this.mealAmountList.filter(s => s.value !== 0)
    },
    enableRegisterAmount() {
      const item = this.item
      if (get(item, 'studentMenu.selectedMenu') === 'menu1' || get(item, 'studentMenu.selectedMenu') === 'menu2') {
        if (this.selectedMenu && this.selectedMenu === '0') return false
        return true
      } else {
        if (this.selectedMenu && this.selectedMenu !== '0') return true
      }

      return false
    },
    enableEditMealTransferStatus() {
      return get(this.item, 'studentMenu.id') && get(this.item, 'mealTransferStatus') !== 'not-eat'
    },
    enableRealAteAmount() {
      if (get(this.item, 'studentMenu.id')) {
        // đã đăng ký & chưa ăn
        if (
          get(this.item, 'mealTransferStatus') === 'not-eat' ||
          (get(this.item, 'mealTransferStatus') === 'not-receive' && !this.realStatus) ||
          this.realStatus === 'not-receive'
        ) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    isRequiredRegisterAmount() {
      if (this.selectedMenu && this.selectedMenu !== get(this.item, 'studentMenu.selectedMenu')) {
        // có thay đổi về thực đơn
        if (this.selectedMenu === 'menu1' || this.selectedMenu === 'menu2') {
          return true
        }
      }

      return false
    }
  },
  methods: {
    ...mapActions('StudentMenuRegister', [
      'updateStudentMenu',
      'createStudentMenu',
      'removeMealTransfer',
      'createMealTransfer',
      'updateMealTransfer'
    ]),
    async save() {
      this.$loading.active = true
      try {
        let data = {}

        // sửa đăng ký món ăn
        if (get(this.item, 'studentMenu.id')) {
          // update
          const menu = this.item.studentMenu.menu
          data.id = this.item.studentMenu.id

          if (this.selectedMenu && this.selectedMenu !== get(this.item, 'studentMenu.selectedMenu')) {
            data.selectedMenu = this.selectedMenu
          }
          if (this.selectedMenu && this.selectedMenu === '0') {
            data.amount = 0
          } else {
            data.amount = this.registedAmount || get(this.item, 'studentMenu.amount')
          }

          if (this.selectedMenu === 'menu1') {
            data.mainDishes = get(menu, 'firstMainDishes')
            data.sideDishes = get(menu, 'firstSideDishes')
          } else if (this.selectedMenu === 'menu2') {
            data.mainDishes = get(menu, 'secondMainDishes')
            data.sideDishes = get(menu, 'secondSideDishes')
          } else if (this.selectedMenu === '0') {
            data.mainDishes = null
            data.sideDishes = null
          }

          // log user
          data.userId = this.user.id
          await this.updateStudentMenu(data)
        } else {
          // create
          const menus = await Menu.fetch({
            date: this.item.date,
            _limit: 1
          })
          if (get(menus, 'length')) {
            const menu = menus[0]

            data = {
              ...data,
              date: this.item.date,
              student: this.item.student.id,
              menu: menu.id,
              day: moment(this.item.date)
                .day()
                .toString(),
              nameToNumber: this.item.student.nameToNumber,
              class: this.item.student.currentClass.id,
              key: this.item.date + this.item.student.id,
              data: {
                createdOnWebAt: moment().toISOString()
              }
            }

            if (this.selectedMenu === 'menu1' || this.selectedMenu === 'menu2') {
              data.amount = this.registedAmount || 1
            } else {
              data.amount = 0
            }

            if (this.selectedMenu === 'menu1') {
              data.selectedMenu = 'menu1'
              data.mainDishes = [get(menu, 'firstMainDishes[0].id')]
              const sideDishes = menu.firstSideDishes.map(d => d.id)
              data.sideDishes = sideDishes || null
            } else if (this.selectedMenu === 'menu2') {
              data.selectedMenu = 'menu2'
              data.mainDishes = [get(menu, 'secondMainDishes[0].id')]
              const sideDishes = menu.secondSideDishes.map(d => d.id)
              data.sideDishes = sideDishes || null
            } else if (this.selectedMenu === '0') {
              data.selectedMenu = '0'
              data.mainDishes = null
              data.sideDishes = null
            } else {
              this.$alert.error('Thực đơn không hợp lệ')
              return
            }

            // log user
            data.userId = this.user.id
            await this.createStudentMenu(data)
          } else {
            this.$alert.error(`Chưa có thực đơn cho ngày ${this.$options.filters.ddmmyyyy(this.item.date)}`)
            return
          }
        }

        // sửa trạng thái ăn
        if (this.realStatus && this.realStatus === 'not-receive') {
          // xóa bản ghi đã tồn tại
          if (get(this.item, 'mealTransfer.id')) {
            await this.removeMealTransfer(this.item.mealTransfer.id)
          }
        } else if (this.realStatus && this.realStatus === 'ate') {
          // create
          if (!get(this.item, 'mealTransfer.id')) {
            const mealTransferData = {
              student: this.item.student.id,
              time: moment(this.item.date)
                .add(12, 'hours')
                .toISOString(),
              key:
                moment(this.item.date)
                  .startOf('day')
                  .toISOString() + this.item.student.id,
              amount: this.realAteAmount || this.registedAmount || get(this.item, 'studentMenu.amount', 1)
            }

            // log user
            mealTransferData.userId = this.user.id
            await this.createMealTransfer(mealTransferData)
          }
        } else if (this.realAteAmount !== null && this.realAteAmount >= 0) {
          // update amount
          if (get(this.item, 'mealTransfer.id')) {
            const mealTransferData = {
              id: this.item.mealTransfer.id,
              amount: this.realAteAmount || this.registedAmount || get(this.item, 'studentMenu.amount', 1)
            }

            // log user
            mealTransferData.userId = this.user.id
            await this.updateMealTransfer(mealTransferData)
          }
        }
        this.$alert.updateSuccess()
        this.$emit('updated')
        this.cancel()
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
      this.$refs.form.reset()
    },
    onSelectedMenuChanged(selectedMenu) {
      if (selectedMenu === '0') this.registedAmount = 0
      else this.registedAmount = null

      this.selectedMenu = selectedMenu
    },
    onMealTransferStatusChanged(status) {
      if (status === 'not-receive') {
        // không ăn
        this.realAteAmount = 0
      } else {
        this.realAteAmount = null
      }
    }
  },

  watch: {
    state(state) {
      this.dialog = true
    },
    selectedMenu: {
      handler(value) {
        this.form && this.form.resetValidation()
      },
      immediate: true
    }
  }
}
</script>
